import React from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as SadNacho } from "../../assets/illustrations/sad_nacho.svg";
import * as styles from "./styles";

const ErrorPage: React.FC = () => {
  return (
    <div className={styles.errorCard}>
      <SadNacho />
      <div style={{ marginTop: "1.5rem" }}>
        <FormattedMessage
          id={"screens.ErrorPage.errorText"}
          defaultMessage={
            "We are currently experiencing some issues with our ticket sale. Please try again later."
          }
        />
      </div>
    </div>
  );
};

export default ErrorPage;
